exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[data-its-slider] {\n  display: block;\n  position: relative;\n  user-select: none;\n}\n", ""]);
